export default __webpack_public_path__ + "static/media/icon-add-plan-rec.c8223c0d.svg";